import type { ReactNode } from "react";

/**
 * The one header pattern for top-level pages: h1 with an optional count badge
 * grouped on the left, page actions (buttons, nav) on the right. Keeps title
 * scale, spacing and action-button sizing identical across pages.
 */
export function PageHeader({
  title,
  badge,
  actions,
}: {
  title: string;
  badge?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="page-head">
      <div className="page-head__title">
        <h1>{title}</h1>
        {badge}
      </div>
      {actions ? <div className="page-head__actions">{actions}</div> : null}
    </div>
  );
}
